import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION2: PdfComponent = {
  type: 'section',
  id: 's3s2',
  title: '2. Kanda Obligations',
  content: [],
};
